// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consultant-tails-tab {
  position: relative;
  padding-top: 25px;
  display: flex;
  justify-content: space-between;
}

.consultant-tails-tab .profile {
  padding: 20px;
  text-align: center;
  white-space: normal;
  word-break: break-all;
  position: relative;
  width: 50%;
}

.consultant-tails-tab .pd-top-view .profile-item ul {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  width: 50%;
  box-shadow: none;
  max-width: 300px;
  margin: auto;
}
.consultant-tails-tab .profile:after {
  content: "";
  position: absolute;
  background: #cacaca;
  width: 2px;
  height: 70%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
}

.consultant-tails-tab .profile-item {
  display: flex;
  width: 100%;
  grid-column: 1 / span 2;
  box-shadow: 0px 0px 4px #b7b7b7;
  border-radius: 12px;
  background: #ffffff;
}
.consultant-tails-tab .profile .dp {
  width: 60px;
  height: 60px;
  margin: auto;
  background: #0066cc;
  color: #ffffff;
  
  font-size: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 60px;
}
.consultant-tails-tab .profile h1 {
  
  font-size: 21px;
  color: #000000;
  margin-top: 15px;
  margin-bottom: 0;
}
.consultant-tails-tab .profile h2 {
  
  font-size: 17px;
  color: #717171;
  font-weight: 400;
  margin: 5px 0px;
}
.consultant-tails-tab .profile h3 {
  
  font-size: 17px;
  color: #717171;
  font-weight: 400;
  margin: 5px 0px;
}
.consultant-tails-tab .profile-details {
  width: 100%;
}
.consultant-tails-tab .profile-details ul {
  list-style-type: none;
  padding: 0px;
  margin: 0px;
}
.consultant-tails-tab .profile-details ul.date_time {
  display: flex;
  margin-top: 5px;
}

.consultant-tails-tab .profile-details ul.date_time li {
  color: #a9a9a9;
  
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  padding: 0px 5px;
}
.consultant-tails-tab .profile-details ul.date_time li:first-child {
  padding-left: 0px;
  border-right: 2px solid #929292;
}
.consultant-tails-tab .pd-tabs-view ul.nav {
  border-bottom: 2px solid #e0dfdf;
  padding-bottom: 10px;
}
.consultant-tails-tab .pd-top-view {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 25px;
}
.consultant-tails-tab .pd-top-view.pd-top-view-2 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 25px;
}
.consultant-tails-tab .pd-top-view ul {
  max-width: 140px;
  margin: auto;
}

.consultant-tails-tab .profile-item-2 {
  background: #ffffff;
  box-shadow: 0px 0px 4px #b7b7b7;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
}
.consultant-tails-tab .pd-top-view .profile-item-2 ul li {
  padding: 0px 20px 0px 10px;
}
.consultant-tails-tab .pd-top-view .profile-item-2 ul li:first-child {
  padding: 0px;
}
.consultant-tails-tab .pd-top-view ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.consultant-tails-tab .pd-top-view ul li p {
  
  font-size: 18px;
  color: #000000;
  margin-bottom: 0px;
}
.consultant-tails-tab .pd-top-view ul li span {
  
  font-size: 15px;
  color: #717171;
  margin-bottom: 0px;
}
.consultant-tails-tab .pd-top-view .profile-item-2 ul li span {
  width: 65px;
}
.consultant-tails-tab .pd-top-view ul li b.dot {
  font-weight: 400;
}

.consultant-tails-tab .pd-top-view ul li b {
  
  font-size: 15px;
  color: #717171;
  margin-bottom: 0px;
}
.consultant-tails-tab .pd-tabs-view {
  background: #ffffff;
  box-shadow: 0px 0px 4px #b7b7b7;
  border-radius: 10px;
  padding: 20px;
  margin-top: 25px;
}
.pd-tabs-view .nav-tabs {
  border: 0px;
}
.pd-tabs-view .nav-tabs .nav-link {
  border: 0px;
  background: #f2f2f2;
  padding: 8px 25px;
  color: #000000;
  font-size: 16px;
  border-radius: 20px;
  margin-right: 15px;
  min-width: 85px;
  text-align: center;
  font-family: var(--relo-font-family);
  font-weight: 500;
  cursor: pointer;
}
.pd-tabs-view .nav-tabs .nav-link.active {
  background: #06c;
  color: #ffffff;
}
.pd-tabs-view .tab-content {
  padding: 10px 0px;
}
.pd-tabs-view .tab-content #tabItinerary {
  margin-top: -25px;
}

.tA-gird-view {
  box-shadow: 0px 2px 3px #c5c5c5;
  padding: 15px;
  background: #f7f7f7;
  margin-bottom: 20px;
  border-radius: 10px;
}
.modal.new_modal_pop .modal-content h6.alert {
  margin-bottom: 0px;
}
.tA-gird-view .top {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #cccccc;
  margin-top: 0px;
  padding-bottom: 7px;
}
.tA-gird-view .top h1 {
  
  font-size: 19px;
  margin: 0px;
  color: #0066cc;
}
.tA-gird-view .top ul {
  display: flex;
  margin: 5px 0px;
}
.tA-gird-view .top ul li {
  padding: 0px 5px;
  border-right: 1px solid #cccccc;
  line-height: 15px;
  
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}
.tA-gird-view .content {
  
  font-size: 16px;
  color: #000000;
  padding: 20px 0px;
  padding-bottom: 0px;
}
.tA-gird-view .content span {
  
  font-size: 16px;
  color: #000000;
}

.modalAddActivity .modal-footer {
  border: 0px;
}
.modalAddActivity .modal-body {
  padding: 20px 50px;
}
.modalAddActivity label {
  margin-bottom: 0px;
  padding-left: 0px;
  font-size: 14px;
  color: #000000;
  position: relative;
  top: -3px;
  z-index: 99;
  font-weight: 500;
  
}
.modalAddActivity .modal-footer .btn {
  padding: 3px 15px;
  
  font-size: 15px;
  font-weight: 400;
}
.modalAddActivity .modal-footer .btn.btn-primary {
  color: #fff;
  background-color: #0066cc;
  border-color: #0066cc;
}
.pd-tabs-view .tab-content h2 {
  color: #030b11;
  text-align: center;
  font-size: 23px;
  font-weight: 400;
}
.pd-tabs-view .pop-form-controls {
  padding: 0px 5px;
  width: 100%;
  margin: auto;
}



.pd-tabs-view .pop-form-controls .form-control.is-invalid,
.pd-tabs-view .pop-form-controls .was-validated .form-control:invalid {
  border-color: #dc3545;
}
.pd-tabs-view .pop-form-controls .ant-select-selection {
  border: 0px;
}
.pd-tabs-view .pop-form-controls .intl-tel-input {
  width: 100%;
}
.pd-tabs-view .pop-form-controls .intl-tel-input input.form-control {
  padding-left: 50px;
  padding-top: 10px;
}

.pd-tabs-view .note_type {
  width: 750px;
  margin: auto;
}
.pd-tabs-view .status_view {
  width: 750px;
  margin: auto;
}
.pd-tabs-view .note_type .chat_msgs {
  padding: 15px;
  text-align: left;
  height: 200px;
  overflow: auto;
  background: #f9f9f9;
  border-radius: 10px;
  margin-bottom: 15px;
}
.pd-tabs-view .note_type .chat_msgs .right_chat {
  float: left;
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 15px 15px 0px 15px;
  box-shadow: 0px 2px 3px #c5c5c5;
}
.pd-tabs-view .note_type .chat_msgs .right_chat_view {
  width: 100%;
  float: left;
  text-align: left;
}

#myModalAddActivity .ant-select-selection {
  border: 0px;
}
#myModalAddActivity .form-control {
  height: 43px;
}
.pd-tabs-view .sch_appointments_thumbs .item h2 {
  font-size: 13px;
  color: #000000;
  font-weight: 700;
}
.calendar-icon-needed .react-datepicker-wrapper .form-control {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: 97% 11px;
  cursor: pointer;
}

.tabProperties a.resend-btn {
  background: #e1251a;
  color: #ffffff;
  padding: 5px 20px;
  width: 230px;
  display: block;
  text-align: center;
  margin: auto;
  border-radius: 7px;
  margin-top: 20px;
  
  font-size: 17px;
}

.focus-input-label.no-edit input.form-control,
.focus-input-label.no-edit .form-control,
.focus-input-label.no-edit .ant-select-selection {
  background: #e9ecef;
}
.pd-tabs-view div#tabEdit {
  position: relative;
}
.pd-tabs-view .a_edit_resendBtn {
  position: absolute;
  right: 0px;
  top: -35px;
}
.pd-tabs-view a.edit_faIcon {
  font-size: 20px;
  color: #007bff;
  position: relative;
  top: 2px;
}
.pd-tabs-view a.a-resend-btn {
  font-size: 15px;
  color: #ffffff !important;
  background: #e1251a;
  
  font-weight: 400;
  padding: 5px 15px;
  border-radius: 6px;
  margin-left: 15px;
}

.non_edit-form .form-control-plaintext {
  box-shadow: none;
  outline: 0px;
}
.pd-tabs-view .non_edit-form.pop-form-controls .form-group.row {
  display: block;
  background: #f1f1f1;
  margin-right: 15px;
  padding: 5px 10px;
  border-radius: 5px;
  padding-top: 0px;
}
.pd-tabs-view .non_edit-form.pop-form-controls label.label_cls {
  font-weight: 400;
  
  top: 0;
  display: block;
  font-size: 11px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  width: 100%;
  max-width: 100%;
  max-height: 45px;
  overflow: auto;
  min-height: 22px;
}
#myModaledit.modal.new_modal_pop .pop-form-controls {
  width: 100%;
}
.pd-tabs-view .non_edit-form.pop-form-controls label.label_cls:last-child {
  font-weight: 500;
  font-size: 15px;
  padding-top: 0;
}
.modal.new_modal_pop .checbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
}
.modal.new_modal_pop .checbox-label {
  margin-top: 30px;
}

.modal.new_modal_pop .checbox-label label.label_cls {
  margin-bottom: 0px;
  padding-left: 3px;
  top: 1px;
}

.tabPreferences .lis-view {
  padding: 0px 5px;
  width: 750px;
  margin: auto;
}
.tabPreferences .lis-view > div {
  border-bottom: 1px dashed #eaeaea;
  padding: 5px 15px;
}
.tabPreferences .lis-view label {
  font-size: 14px;
  color: #bfbfbf;
  margin-bottom: 0px;
}
.tabPreferences .lis-view span {
  display: block;
  font-size: 15px;
  
  font-weight: 500;
}
.tabPreferences button.close {
  color: #333;
  font-weight: 100;
  text-align: right;
  font-size: 18px;
  padding-right: 10px;
  padding-top: 5px;
  margin: 0px;
  padding-bottom: 0px;
}
.tabPreferences .modal-header {
  border: 0px;
  padding-bottom: 0px;
}
.tabPreferences .modal-header .modal-title {
  font-size: 18px;
  color: #5f5f5f;
}

@media (max-width: 991px) {
  .pd-tabs-view .note_type {
    width: 90%;
    margin: auto;
  }
  .pd-tabs-view .status_view {
    width: 90%;
    margin: auto;
  }
  .pd-tabs-view .pop-form-controls {
    width: 90%;
  }
}
@media (max-width: 767px) {
  .consultant-tails-tab .pd-top-view {
    grid-template-columns: repeat(1, 1fr);
    grid-column-gap: 0;
  }
  .consultant-tails-tab .pd-top-view.pd-top-view-2 {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 567px) {
  .consultant-tails-tab .profile:after {
    width: 70%;
    height: 2px;
    margin: auto;
    left: 0px;
    right: 0px;
    bottom: 0px;
    top: auto;
  }
  .consultant-tails-tab .profile-item {
    grid-column: auto;
    flex-direction: column;
  }
  .consultant-tails-tab .profile {
    width: 100%;
  }
  .consultant-tails-tab .pd-top-view .profile-item ul {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./app/pages/Supplier/moredetails/moredetails.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;;EAEjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;;AAElB;AACA;EACE,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;;;AAIA;;EAEE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yDAA2D;EAC3D,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;;EAEnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;;EAEhB,MAAM;EACN,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;;EAEf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,qCAAqC;IACrC,kBAAkB;EACpB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".consultant-tails-tab {\n  position: relative;\n  padding-top: 25px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.consultant-tails-tab .profile {\n  padding: 20px;\n  text-align: center;\n  white-space: normal;\n  word-break: break-all;\n  position: relative;\n  width: 50%;\n}\n\n.consultant-tails-tab .pd-top-view .profile-item ul {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 20px;\n  width: 50%;\n  box-shadow: none;\n  max-width: 300px;\n  margin: auto;\n}\n.consultant-tails-tab .profile:after {\n  content: \"\";\n  position: absolute;\n  background: #cacaca;\n  width: 2px;\n  height: 70%;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  margin: auto;\n}\n\n.consultant-tails-tab .profile-item {\n  display: flex;\n  width: 100%;\n  grid-column: 1 / span 2;\n  box-shadow: 0px 0px 4px #b7b7b7;\n  border-radius: 12px;\n  background: #ffffff;\n}\n.consultant-tails-tab .profile .dp {\n  width: 60px;\n  height: 60px;\n  margin: auto;\n  background: #0066cc;\n  color: #ffffff;\n  \n  font-size: 20px;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 60px;\n}\n.consultant-tails-tab .profile h1 {\n  \n  font-size: 21px;\n  color: #000000;\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n.consultant-tails-tab .profile h2 {\n  \n  font-size: 17px;\n  color: #717171;\n  font-weight: 400;\n  margin: 5px 0px;\n}\n.consultant-tails-tab .profile h3 {\n  \n  font-size: 17px;\n  color: #717171;\n  font-weight: 400;\n  margin: 5px 0px;\n}\n.consultant-tails-tab .profile-details {\n  width: 100%;\n}\n.consultant-tails-tab .profile-details ul {\n  list-style-type: none;\n  padding: 0px;\n  margin: 0px;\n}\n.consultant-tails-tab .profile-details ul.date_time {\n  display: flex;\n  margin-top: 5px;\n}\n\n.consultant-tails-tab .profile-details ul.date_time li {\n  color: #a9a9a9;\n  \n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14px;\n  padding: 0px 5px;\n}\n.consultant-tails-tab .profile-details ul.date_time li:first-child {\n  padding-left: 0px;\n  border-right: 2px solid #929292;\n}\n.consultant-tails-tab .pd-tabs-view ul.nav {\n  border-bottom: 2px solid #e0dfdf;\n  padding-bottom: 10px;\n}\n.consultant-tails-tab .pd-top-view {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 25px;\n}\n.consultant-tails-tab .pd-top-view.pd-top-view-2 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 25px;\n}\n.consultant-tails-tab .pd-top-view ul {\n  max-width: 140px;\n  margin: auto;\n}\n\n.consultant-tails-tab .profile-item-2 {\n  background: #ffffff;\n  box-shadow: 0px 0px 4px #b7b7b7;\n  border-radius: 10px;\n  padding: 20px;\n  width: 100%;\n}\n.consultant-tails-tab .pd-top-view .profile-item-2 ul li {\n  padding: 0px 20px 0px 10px;\n}\n.consultant-tails-tab .pd-top-view .profile-item-2 ul li:first-child {\n  padding: 0px;\n}\n.consultant-tails-tab .pd-top-view ul li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.consultant-tails-tab .pd-top-view ul li p {\n  \n  font-size: 18px;\n  color: #000000;\n  margin-bottom: 0px;\n}\n.consultant-tails-tab .pd-top-view ul li span {\n  \n  font-size: 15px;\n  color: #717171;\n  margin-bottom: 0px;\n}\n.consultant-tails-tab .pd-top-view .profile-item-2 ul li span {\n  width: 65px;\n}\n.consultant-tails-tab .pd-top-view ul li b.dot {\n  font-weight: 400;\n}\n\n.consultant-tails-tab .pd-top-view ul li b {\n  \n  font-size: 15px;\n  color: #717171;\n  margin-bottom: 0px;\n}\n.consultant-tails-tab .pd-tabs-view {\n  background: #ffffff;\n  box-shadow: 0px 0px 4px #b7b7b7;\n  border-radius: 10px;\n  padding: 20px;\n  margin-top: 25px;\n}\n.pd-tabs-view .nav-tabs {\n  border: 0px;\n}\n.pd-tabs-view .nav-tabs .nav-link {\n  border: 0px;\n  background: #f2f2f2;\n  padding: 8px 25px;\n  color: #000000;\n  font-size: 16px;\n  border-radius: 20px;\n  margin-right: 15px;\n  min-width: 85px;\n  text-align: center;\n  font-family: var(--relo-font-family);\n  font-weight: 500;\n  cursor: pointer;\n}\n.pd-tabs-view .nav-tabs .nav-link.active {\n  background: #06c;\n  color: #ffffff;\n}\n.pd-tabs-view .tab-content {\n  padding: 10px 0px;\n}\n.pd-tabs-view .tab-content #tabItinerary {\n  margin-top: -25px;\n}\n\n.tA-gird-view {\n  box-shadow: 0px 2px 3px #c5c5c5;\n  padding: 15px;\n  background: #f7f7f7;\n  margin-bottom: 20px;\n  border-radius: 10px;\n}\n.modal.new_modal_pop .modal-content h6.alert {\n  margin-bottom: 0px;\n}\n.tA-gird-view .top {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #cccccc;\n  margin-top: 0px;\n  padding-bottom: 7px;\n}\n.tA-gird-view .top h1 {\n  \n  font-size: 19px;\n  margin: 0px;\n  color: #0066cc;\n}\n.tA-gird-view .top ul {\n  display: flex;\n  margin: 5px 0px;\n}\n.tA-gird-view .top ul li {\n  padding: 0px 5px;\n  border-right: 1px solid #cccccc;\n  line-height: 15px;\n  \n  font-size: 16px;\n  color: #000000;\n  font-weight: 500;\n}\n.tA-gird-view .content {\n  \n  font-size: 16px;\n  color: #000000;\n  padding: 20px 0px;\n  padding-bottom: 0px;\n}\n.tA-gird-view .content span {\n  \n  font-size: 16px;\n  color: #000000;\n}\n\n.modalAddActivity .modal-footer {\n  border: 0px;\n}\n.modalAddActivity .modal-body {\n  padding: 20px 50px;\n}\n.modalAddActivity label {\n  margin-bottom: 0px;\n  padding-left: 0px;\n  font-size: 14px;\n  color: #000000;\n  position: relative;\n  top: -3px;\n  z-index: 99;\n  font-weight: 500;\n  \n}\n.modalAddActivity .modal-footer .btn {\n  padding: 3px 15px;\n  \n  font-size: 15px;\n  font-weight: 400;\n}\n.modalAddActivity .modal-footer .btn.btn-primary {\n  color: #fff;\n  background-color: #0066cc;\n  border-color: #0066cc;\n}\n.pd-tabs-view .tab-content h2 {\n  color: #030b11;\n  text-align: center;\n  font-size: 23px;\n  font-weight: 400;\n}\n.pd-tabs-view .pop-form-controls {\n  padding: 0px 5px;\n  width: 100%;\n  margin: auto;\n}\n\n\n\n.pd-tabs-view .pop-form-controls .form-control.is-invalid,\n.pd-tabs-view .pop-form-controls .was-validated .form-control:invalid {\n  border-color: #dc3545;\n}\n.pd-tabs-view .pop-form-controls .ant-select-selection {\n  border: 0px;\n}\n.pd-tabs-view .pop-form-controls .intl-tel-input {\n  width: 100%;\n}\n.pd-tabs-view .pop-form-controls .intl-tel-input input.form-control {\n  padding-left: 50px;\n  padding-top: 10px;\n}\n\n.pd-tabs-view .note_type {\n  width: 750px;\n  margin: auto;\n}\n.pd-tabs-view .status_view {\n  width: 750px;\n  margin: auto;\n}\n.pd-tabs-view .note_type .chat_msgs {\n  padding: 15px;\n  text-align: left;\n  height: 200px;\n  overflow: auto;\n  background: #f9f9f9;\n  border-radius: 10px;\n  margin-bottom: 15px;\n}\n.pd-tabs-view .note_type .chat_msgs .right_chat {\n  float: left;\n  width: 100%;\n  background-color: #f7f7f7;\n  border-radius: 15px 15px 0px 15px;\n  box-shadow: 0px 2px 3px #c5c5c5;\n}\n.pd-tabs-view .note_type .chat_msgs .right_chat_view {\n  width: 100%;\n  float: left;\n  text-align: left;\n}\n\n#myModalAddActivity .ant-select-selection {\n  border: 0px;\n}\n#myModalAddActivity .form-control {\n  height: 43px;\n}\n.pd-tabs-view .sch_appointments_thumbs .item h2 {\n  font-size: 13px;\n  color: #000000;\n  font-weight: 700;\n}\n.calendar-icon-needed .react-datepicker-wrapper .form-control {\n  background-image: url('/public/assets/images/calendar.svg');\n  background-size: 20px;\n  background-repeat: no-repeat;\n  background-position: 97% 11px;\n  cursor: pointer;\n}\n\n.tabProperties a.resend-btn {\n  background: #e1251a;\n  color: #ffffff;\n  padding: 5px 20px;\n  width: 230px;\n  display: block;\n  text-align: center;\n  margin: auto;\n  border-radius: 7px;\n  margin-top: 20px;\n  \n  font-size: 17px;\n}\n\n.focus-input-label.no-edit input.form-control,\n.focus-input-label.no-edit .form-control,\n.focus-input-label.no-edit .ant-select-selection {\n  background: #e9ecef;\n}\n.pd-tabs-view div#tabEdit {\n  position: relative;\n}\n.pd-tabs-view .a_edit_resendBtn {\n  position: absolute;\n  right: 0px;\n  top: -35px;\n}\n.pd-tabs-view a.edit_faIcon {\n  font-size: 20px;\n  color: #007bff;\n  position: relative;\n  top: 2px;\n}\n.pd-tabs-view a.a-resend-btn {\n  font-size: 15px;\n  color: #ffffff !important;\n  background: #e1251a;\n  \n  font-weight: 400;\n  padding: 5px 15px;\n  border-radius: 6px;\n  margin-left: 15px;\n}\n\n.non_edit-form .form-control-plaintext {\n  box-shadow: none;\n  outline: 0px;\n}\n.pd-tabs-view .non_edit-form.pop-form-controls .form-group.row {\n  display: block;\n  background: #f1f1f1;\n  margin-right: 15px;\n  padding: 5px 10px;\n  border-radius: 5px;\n  padding-top: 0px;\n}\n.pd-tabs-view .non_edit-form.pop-form-controls label.label_cls {\n  font-weight: 400;\n  \n  top: 0;\n  display: block;\n  font-size: 11px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n  width: 100%;\n  max-width: 100%;\n  max-height: 45px;\n  overflow: auto;\n  min-height: 22px;\n}\n#myModaledit.modal.new_modal_pop .pop-form-controls {\n  width: 100%;\n}\n.pd-tabs-view .non_edit-form.pop-form-controls label.label_cls:last-child {\n  font-weight: 500;\n  font-size: 15px;\n  padding-top: 0;\n}\n.modal.new_modal_pop .checbox-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n}\n.modal.new_modal_pop .checbox-label {\n  margin-top: 30px;\n}\n\n.modal.new_modal_pop .checbox-label label.label_cls {\n  margin-bottom: 0px;\n  padding-left: 3px;\n  top: 1px;\n}\n\n.tabPreferences .lis-view {\n  padding: 0px 5px;\n  width: 750px;\n  margin: auto;\n}\n.tabPreferences .lis-view > div {\n  border-bottom: 1px dashed #eaeaea;\n  padding: 5px 15px;\n}\n.tabPreferences .lis-view label {\n  font-size: 14px;\n  color: #bfbfbf;\n  margin-bottom: 0px;\n}\n.tabPreferences .lis-view span {\n  display: block;\n  font-size: 15px;\n  \n  font-weight: 500;\n}\n.tabPreferences button.close {\n  color: #333;\n  font-weight: 100;\n  text-align: right;\n  font-size: 18px;\n  padding-right: 10px;\n  padding-top: 5px;\n  margin: 0px;\n  padding-bottom: 0px;\n}\n.tabPreferences .modal-header {\n  border: 0px;\n  padding-bottom: 0px;\n}\n.tabPreferences .modal-header .modal-title {\n  font-size: 18px;\n  color: #5f5f5f;\n}\n\n@media (max-width: 991px) {\n  .pd-tabs-view .note_type {\n    width: 90%;\n    margin: auto;\n  }\n  .pd-tabs-view .status_view {\n    width: 90%;\n    margin: auto;\n  }\n  .pd-tabs-view .pop-form-controls {\n    width: 90%;\n  }\n}\n@media (max-width: 767px) {\n  .consultant-tails-tab .pd-top-view {\n    grid-template-columns: repeat(1, 1fr);\n    grid-column-gap: 0;\n  }\n  .consultant-tails-tab .pd-top-view.pd-top-view-2 {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media (max-width: 567px) {\n  .consultant-tails-tab .profile:after {\n    width: 70%;\n    height: 2px;\n    margin: auto;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    top: auto;\n  }\n  .consultant-tails-tab .profile-item {\n    grid-column: auto;\n    flex-direction: column;\n  }\n  .consultant-tails-tab .profile {\n    width: 100%;\n  }\n  .consultant-tails-tab .pd-top-view .profile-item ul {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
